export const getOnlineTransactionsQueries = (values) => {
  let queryConditions = "";
  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `${queryConditions ? "&" : "?"}startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values?.transactionId) {
    queryConditions += `${queryConditions ? "&" : "?"}transactionId=${
      values?.transactionId
    }`;
  }

  if (values?.propertyUniqueId) {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values?.propertyUniqueId
    }`;
  }

  if (values?.paymentMethod) {
    queryConditions += `${queryConditions ? "&" : "?"}paymentMethod=${
      values?.paymentMethod
    }`;
  }

  if (values?.page && values?.pageSize) {
    queryConditions += `${queryConditions ? "&" : "?"}page=${
      values?.page
    }&limit=${values?.pageSize}`;
  }

  if (values?.zoneId) {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values?.zoneId}`;
  }

  if (values?.wardId) {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values?.wardId}`;
  }

  if (values?.mohallaId) {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values?.mohallaId
    }`;
  }

  if (values?.houseCategory) {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values?.houseCategory
    }`;
  }

  return queryConditions;
};

export const getOfflineTransactionsQueries = (values) => {
  let queryConditions = "";

  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `${queryConditions ? "&" : "?"}startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values?.transactionId) {
    queryConditions += `${queryConditions ? "&" : "?"}transactionId=${
      values?.transactionId
    }`;
  }

  if (values?.propertyUniqueId) {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values?.propertyUniqueId
    }`;
  }

  if (values?.transactionType) {
    queryConditions += `${queryConditions ? "&" : "?"}transactionType=${
      values?.transactionType
    }`;
  }

  if (values?.zoneId) {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values?.zoneId}`;
  }

  if (values?.wardId) {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values?.wardId}`;
  }

  if (values?.mohallaId) {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values?.mohallaId
    }`;
  }

  if (values?.houseCategory) {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values?.houseCategory
    }`;
  }

  if (values?.chequeNo) {
    queryConditions += `${queryConditions ? "&" : "?"}chequeNo=${
      values?.chequeNo
    }`;
  }

  if (values?.ddNo) {
    queryConditions += `${queryConditions ? "&" : "?"}ddNo=${values?.ddNo}`;
  }

  if (values?.page && values?.pageSize) {
    queryConditions += `${queryConditions ? "&" : "?"}page=${
      values?.page
    }&limit=${values?.pageSize}`;
  }

  return queryConditions;
};

export const getNeftTransactionsQueries = (values) => {
  let queryConditions = "";

  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `${queryConditions ? "&" : "?"}startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values?.transactionId) {
    queryConditions += `${queryConditions ? "&" : "?"}transactionId=${
      values?.transactionId
    }`;
  }

  if (values?.propertyUniqueId) {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values?.propertyUniqueId
    }`;
  }

  if (values?.transactionType) {
    queryConditions += `${queryConditions ? "&" : "?"}transactionType=${
      values?.transactionType
    }`;
  }

  if (values?.zoneId) {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values?.zoneId}`;
  }

  if (values?.wardId) {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values?.wardId}`;
  }

  if (values?.mohallaId) {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values?.mohallaId
    }`;
  }

  if (values?.houseCategory) {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values?.houseCategory
    }`;
  }

  if (values?.page && values?.pageSize) {
    queryConditions += `${queryConditions ? "&" : "?"}page=${
      values?.page
    }&limit=${values?.pageSize}`;
  }

  return queryConditions;
};

export const getObjectionQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.ownerName && values.ownerName !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}ownerName=${
      values.ownerName
    }`;
  }
  if (values.houseNumber && values.houseNumber !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseNumber=${
      values.houseNumber
    }`;
  }
  if (values.propertyUniqueId && values.propertyUniqueId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values.propertyUniqueId
    }`;
  }
  if (values.objectionStatus && values.objectionStatus !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}objectionStatus=${
      values.objectionStatus
    }`;
  }
  if (values.uploaderType && values.uploaderType !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}uploaderType=${
      values.uploaderType
    }`;
  }
  if (values.objectionDate && values.objectionDate !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}objectionDate=${
      values.objectionDate
    }`;
  }

  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `?startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values.resolvedDates && values?.resolvedDates.length === 2) {
    const resolvedStartDate = new Date(
      values.resolvedDates[0]
    ).toLocaleDateString("en-CA");
    const resolvedEndDate = new Date(
      values.resolvedDates[1]
    ).toLocaleDateString("en-CA");

    queryConditions += `${
      queryConditions ? "&" : "?"
    }resolvedStartDate=${resolvedStartDate}&resolvedEndDate=${resolvedEndDate}`;
  }

  if (values?.page && values?.pageSize) {
    queryConditions += `${queryConditions ? "&" : "?"}page=${
      values?.page
    }&limit=${values?.pageSize}`;
  }

  return queryConditions;
};

export const getEditedPropertiesQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.ownerName && values.ownerName !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}ownerName=${
      values.ownerName
    }`;
  }
  if (values.houseNumber && values.houseNumber !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseNumber=${
      values.houseNumber
    }`;
  }
  if (values.propertyUniqueId && values.propertyUniqueId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values.propertyUniqueId
    }`;
  }

  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `${queryConditions ? "&" : "?"}startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values?.page && values?.pageSize) {
    queryConditions += `${queryConditions ? "&" : "?"}page=${
      values?.page
    }&limit=${values?.pageSize}`;
  }

  return queryConditions;
};

export const getDemandQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.year && values.year !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}year=${new Date(
      values.year
    ).getFullYear()}`;
  }

  return queryConditions;
};

export const getDefaulterQueries = (paginationQuery, values, queryType) => {
  let queryConditions = "";

  if (paginationQuery.page && paginationQuery.pageSize) {
    queryConditions += `?page=${paginationQuery.page}&limit=${paginationQuery.pageSize}`;
  }

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.filterType && values.filterType !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}filterType=${
      values.filterType
    }`;
  }
  if (values.minAmount || values.maxAmount) {
    queryConditions += `${queryConditions ? "&" : "?"}minAmount=${
      values.minAmount ?? 100000
    }`;
    queryConditions += `${queryConditions ? "&" : "?"}maxAmount=${
      values.maxAmount ?? 500000
    }`;
  }
  if (values.houseCategory && values.houseCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values.houseCategory
    }`;
  }
  if (values.category && values.category !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}category=${
      values.category
    }`;
  }
  if (values.subCategory && values.subCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}subCategory=${
      values.subCategory
    }`;
  }
  if (values.matchingStatus && values.matchingStatus !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}matchingStatus=${
      values.matchingStatus
    }`;
  }

  return queryConditions;
};

export const getARVQueries = (paginationQuery, values) => {
  let queryConditions = "";

  if (paginationQuery.page && paginationQuery.pageSize) {
    queryConditions += `?page=${paginationQuery.page}&limit=${paginationQuery.pageSize}`;
  }

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.minAmount || values.maxAmount) {
    queryConditions += `${queryConditions ? "&" : "?"}minAmount=${
      values.minAmount ?? 100000
    }`;
    queryConditions += `${queryConditions ? "&" : "?"}maxAmount=${
      values.maxAmount ?? 500000
    }`;
  }
  if (values.houseCategory && values.houseCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values.houseCategory
    }`;
  }
  if (values.category && values.category !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}category=${
      values.category
    }`;
  }
  if (values.subCategory && values.subCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}subCategory=${
      values.subCategory
    }`;
  }
  if (values.matchingStatus && values.matchingStatus !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}matchingStatus=${
      values.matchingStatus
    }`;
  }

  return queryConditions;
};

export const getDrCrQueries = (paginationQuery, values) => {
  let queryConditions = "";

  if (paginationQuery.page && paginationQuery.pageSize) {
    queryConditions += `?page=${paginationQuery.page}&limit=${paginationQuery.pageSize}`;
  }

  if (values?.zoneId && values?.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values?.zoneId}`;
  }
  if (values?.wardId && values?.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values?.wardId}`;
  }
  if (values?.mohallaId && values?.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values?.mohallaId
    }`;
  }
  if (values?.propertyUniqueId && values.propertyUniqueId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values.propertyUniqueId
    }`;
  }
  if (values?.debitCreditNo && values?.debitCreditNo !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}debitCreditNo=${
      values?.debitCreditNo
    }`;
  }

  return queryConditions;
};

export const getPropertyQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }

  if (values.propertyUniqueId && values.propertyUniqueId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values.propertyUniqueId
    }`;
  }

  if (values.oldPropertyTaxId && values.oldPropertyTaxId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}oldPropertyTaxId=${
      values.oldPropertyTaxId
    }`;
  }

  if (values.ownerName && values.ownerName !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}ownerName=${
      values.ownerName
    }`;
  }
  if (values.fatherName && values.fatherName !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}fatherName=${
      values.fatherName
    }`;
  }
  if (values.mobileNumber && values.mobileNumber !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mobileNumber=${
      values.mobileNumber
    }`;
  }
  if (values.houseNumber && values.houseNumber !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseNumber=${
      values.houseNumber
    }`;
  }

  if (values.category && values.category !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}category=${
      values.category
    }`;
  }
  if (values.subCategory && values.subCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}subCategory=${
      values.subCategory
    }`;
  }

  if (values.buildingId && values.buildingId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}buildingId=${
      values.buildingId
    }`;
  }

  return queryConditions;
};

export const getCollectionQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }

  if (values.houseCategory && values.houseCategory !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}houseCategory=${
      values.houseCategory
    }`;
  }

  if (values.method && values.method !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}method=${values.method}`;
  }
  if (values.mode && values.mode !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mode=${values.mode}`;
  }

  if (values?.dates && values?.dates.length === 2) {
    queryConditions += `${queryConditions ? "&" : "?"}startDate=${new Date(
      values?.dates[0]
    ).toLocaleDateString("en-CA")}&endDate=${new Date(
      values?.dates[1]
    ).toLocaleDateString("en-CA")}`;
  }

  if (values.year && values.year !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}year=${new Date(
      values.year
    ).getFullYear()}`;
  }

  return queryConditions;
};

export const getDashboardQueries = (paginationQuery, values) => {
  let queryConditions = "";

  if (paginationQuery.page && paginationQuery.pageSize) {
    queryConditions += `page=${paginationQuery.page}&limit=${paginationQuery.pageSize}`;
  }

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `&zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `&wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `&mohallaId=${values.mohallaId}`;
  }

  return queryConditions;
};

export const getMutationQueries = (values) => {
  let queryConditions = "";

  if (values.zoneId && values.zoneId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}zoneId=${values.zoneId}`;
  }
  if (values.wardId && values.wardId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}wardId=${values.wardId}`;
  }
  if (values.mohallaId && values.mohallaId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mohallaId=${
      values.mohallaId
    }`;
  }
  if (values.propertyUniqueId && values.propertyUniqueId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}propertyUniqueId=${
      values.propertyUniqueId
    }`;
  }
  if (values.mutationId && values.mutationId !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}mutationId=${
      values.mutationId
    }`;
  }
  if (values.status && values.status !== "") {
    queryConditions += `${queryConditions ? "&" : "?"}status=${values.status}`;
  }

  return queryConditions;
};
